import { Pipe, PipeTransform } from '@angular/core';

import { Subscription } from '../entities/index';

@Pipe({name: 'subscriptionAmount'})
export class SubscriptionAmountPipe implements PipeTransform {
  transform(value: Subscription, args: string[]): any {
    return (value.amount / 100).toFixed(2) + ' €';
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/pipes/subscription-amount.pipe.ts